<template>
  <div class="un-authorized-page valign-center flex-center">
    <span>用户没有权限</span>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.un-authorized-page {
  width: 100%;
  height: 100%;
}
</style>